// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_UTCTime from "../Data.UTCTime/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Orders_Types_Coupon from "../Restaumatic.Orders.Types.Coupon/index.js";
import * as Restaumatic_Orders_Types_FulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic_Orders_Types_Id from "../Restaumatic.Orders.Types.Id/index.js";
import * as Restaumatic_Orders_Types_OrderOrigin from "../Restaumatic.Orders.Types.OrderOrigin/index.js";
import * as Restaumatic_TypesGen from "../Restaumatic.TypesGen/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var ItemInfo = function (x) {
    return x;
};
var DiscountInfo = function (x) {
    return x;
};
var OrderInfo = function (x) {
    return x;
};
var eqItemInfo = {
    eq: function (x) {
        return function (y) {
            return x.name === y.name && x.promotion === y.promotion && x.quantity === y.quantity && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.total)(y.total) && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.unitPrice)(y.unitPrice);
        };
    }
};
var eqDiscountInfo = {
    eq: function (x) {
        return function (y) {
            return x.name === y.name && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.value)(y.value);
        };
    }
};
var eqOrderInfo = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Orders_Types_Coupon.eqCoupon))(x.coupons)(y.coupons) && Data_Eq.eq(Restaumatic_TypesGen.eqCurrency)(x.currency)(y.currency) && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.deliveryCost)(y.deliveryCost) && Data_Eq.eq(Data_Eq.eqArray(eqDiscountInfo))(x.discounts)(y.discounts) && Data_Eq.eq(Restaumatic_Orders_Types_FulfillmentMethodType.eqFulfillmentMethodType)(x.fulfillmentMethodType)(y.fulfillmentMethodType) && Data_Eq.eq(Restaumatic_Orders_Types_Id.eqOrderId)(x.id)(y.id) && Data_Eq.eq(Data_Eq.eqArray(eqItemInfo))(x.items)(y.items) && x.onlinePayment === y.onlinePayment && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Orders_Types_OrderOrigin.eqOrderOrigin))(x.origin)(y.origin) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_UTCTime.eqUTCTime))(x.requestedFulfillmentTime)(y.requestedFulfillmentTime) && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.total)(y.total);
        };
    }
};
var newtypeOrderInfo = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeItemInfo = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDiscountInfo = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldOrderInfo = function (dictHasField) {
    return dictHasField;
};
var hasFieldItemInfo = function (dictHasField) {
    return dictHasField;
};
var hasFieldDiscountInfo = function (dictHasField) {
    return dictHasField;
};
var genericOrderInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericItemInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showItemInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericItemInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotion";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "total";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "unitPrice";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))(Data_Money_Rounded.showMoney))(Data_Show.showInt))(Data_Show.showBoolean))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "ItemInfo";
        }
    }))
};
var unscrambleDecodeItemInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericItemInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotion";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "quantity";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "total";
        }
    })(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "unitPrice";
        }
    })(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordNil)))))))))(Unscramble_Generic.defaultOptions)
};
var genericDiscountInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showDiscountInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDiscountInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "value";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "DiscountInfo";
        }
    }))
};
var showOrderInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "coupons";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "currency";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "deliveryCost";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "discounts";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "fulfillmentMethodType";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "onlinePayment";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "origin";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "requestedFulfillmentTime";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "total";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_UTCTime.showUTCTime)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Orders_Types_OrderOrigin.showOrderOrigin)))(Data_Show.showBoolean))(/* #__PURE__ */ Data_Show.showArray(showItemInfo)))(Restaumatic_Orders_Types_Id.showOrderId))(Restaumatic_Orders_Types_FulfillmentMethodType.showFulfillmentMethodType))(/* #__PURE__ */ Data_Show.showArray(showDiscountInfo)))(Data_Money_Rounded.showMoney))(Restaumatic_TypesGen.showCurrency))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Orders_Types_Coupon.showCoupon)))))({
        reflectSymbol: function () {
            return "OrderInfo";
        }
    }))
};
var unscrambleDecodeDiscountInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericDiscountInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "value";
        }
    })(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeOrderInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "coupons";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Orders_Types_Coupon.unscrambleDecodeCoupon))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "currency";
        }
    })(Restaumatic_TypesGen.unscrambleDecodeCurrency)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "deliveryCost";
        }
    })(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "discounts";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeDiscountInfo))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "fulfillmentMethodType";
        }
    })(Restaumatic_Orders_Types_FulfillmentMethodType.unscrambleDecodeFulfillmentMethodType)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Orders_Types_Id.udecodeOrderId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeItemInfo))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "onlinePayment";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "origin";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Orders_Types_OrderOrigin.unscrambleDecodeOrderOrigin))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "requestedFulfillmentTime";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Data_UTCTime.unscrambleDecodeUTCTime))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "total";
        }
    })(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordNil)))))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeItemInfo = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericItemInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ItemInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "unitPrice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "total";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "promotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var encodeDiscountInfo = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericDiscountInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "DiscountInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var encodeOrderInfo = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericOrderInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "OrderInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "total";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "requestedFulfillmentTime";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Data_UTCTime.encodeUTCTime))))({
        reflectSymbol: function () {
            return "origin";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Orders_Types_OrderOrigin.encodeOrderOrigin))))({
        reflectSymbol: function () {
            return "onlinePayment";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeItemInfo))))({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Types_Id.encodeOrderId)))({
        reflectSymbol: function () {
            return "fulfillmentMethodType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Types_FulfillmentMethodType.encodeFulfillmentMethodType)))({
        reflectSymbol: function () {
            return "discounts";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeDiscountInfo))))({
        reflectSymbol: function () {
            return "deliveryCost";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "currency";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_TypesGen.encodeCurrency)))({
        reflectSymbol: function () {
            return "coupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Orders_Types_Coupon.encodeCoupon)))))))(encodingOpts)
};
var decodeItemInfo = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericItemInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ItemInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "unitPrice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "total";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "promotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeDiscountInfo = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericDiscountInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "DiscountInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeOrderInfo = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericOrderInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "OrderInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "total";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "requestedFulfillmentTime";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Data_UTCTime.decodeUTCTime)))())({
        reflectSymbol: function () {
            return "origin";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Orders_Types_OrderOrigin.decodeOrderOrigin)))())({
        reflectSymbol: function () {
            return "onlinePayment";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeItemInfo)))())({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Types_Id.decodeOrderId))())({
        reflectSymbol: function () {
            return "fulfillmentMethodType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Types_FulfillmentMethodType.decodeFulfillmentMethodType))())({
        reflectSymbol: function () {
            return "discounts";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeDiscountInfo)))())({
        reflectSymbol: function () {
            return "deliveryCost";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "currency";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_TypesGen.decodeCurrency))())({
        reflectSymbol: function () {
            return "coupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Orders_Types_Coupon.decodeCoupon)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    DiscountInfo,
    ItemInfo,
    OrderInfo,
    encodingOpts,
    genericDiscountInfo,
    showDiscountInfo,
    eqDiscountInfo,
    decodeDiscountInfo,
    unscrambleDecodeDiscountInfo,
    encodeDiscountInfo,
    newtypeDiscountInfo,
    hasFieldDiscountInfo,
    genericItemInfo,
    showItemInfo,
    eqItemInfo,
    decodeItemInfo,
    unscrambleDecodeItemInfo,
    encodeItemInfo,
    newtypeItemInfo,
    hasFieldItemInfo,
    genericOrderInfo,
    showOrderInfo,
    eqOrderInfo,
    decodeOrderInfo,
    unscrambleDecodeOrderInfo,
    encodeOrderInfo,
    newtypeOrderInfo,
    hasFieldOrderInfo
};
//# sourceMappingURL=index.js.map
